import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/user.svg'


const _hoisted_1 = { class: "flex justify-between p-10 pt-2 items-center text-white z-20" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "font-normal text-1" }
const _hoisted_4 = { class: "font-bold text-1" }
const _hoisted_5 = ["onclick"]
const _hoisted_6 = ["onclick"]
const _hoisted_7 = { class: "pl-5 text-xs py-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.subTitle), 1)
    ]),
    _createElementVNode("div", {
      class: "rounded-r-full bg-blue-400 px-2 w-28 relative hover:cursor-pointer",
      onclick: _ctx.showModalLogout
    }, [
      _createElementVNode("div", {
        class: "rounded-full flex justify-center bg-white w-9 h-9 hover:cursor-pointer icon_user_header",
        onclick: _ctx.showModalLogout
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("img", {
          src: _imports_0,
          class: "w-5"
        }, null, -1)
      ]), 8, _hoisted_6),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.userName), 1)
    ], 8, _hoisted_5)
  ]))
}